import * as CodeMirror from 'codemirror/lib/codemirror';
import 'codemirror/mode/meta';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/markdown/markdown';
import 'codemirror/mode/python/python';
import 'codemirror/mode/cmake/cmake';
import 'codemirror/mode/clike/clike';

export default CodeMirror;
